var _path, _path2, _rect, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 97,
    viewBox: "0 0 105 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H85C96.0457 0 105 8.9543 105 20V77C105 88.0457 96.0457 97 85 97H20C8.9543 97 0 88.0457 0 77V20Z",
    fill: "#4247C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9547 31.3022H71.2124V26.9893C71.2124 23.7787 68.5904 21.1567 65.3798 21.1567H39.6309C36.4203 21.1567 33.7983 23.7787 33.7983 26.9893V31.3129H27.056C24.83 31.3129 23 33.143 23 35.369V71.7878C23 74.0139 24.83 75.8438 27.056 75.8438H77.944C80.17 75.8438 81.9999 74.0138 81.9999 71.7878V35.369C82.0107 33.0787 80.1807 31.3022 77.9547 31.3022ZM33.8732 73.1576H31.6472V33.9242H33.8732V73.1576ZM63.8708 56.7194C63.8708 57.8966 62.9504 58.8171 61.8375 58.8171H57.8456V62.8089C57.8456 63.9861 56.9895 64.8423 55.8123 64.8423H49.3269C48.1496 64.8423 47.2935 63.9218 47.2935 62.8089V58.8171H43.3016C42.1244 58.8171 41.2683 57.8966 41.2683 56.7194V50.2982C41.2683 49.121 42.1886 48.2006 43.3016 48.2006H47.2935V44.2088C47.2935 43.0316 48.2139 42.1112 49.3269 42.1112H55.8124C56.9896 42.1112 57.8457 43.0316 57.8457 44.2088V48.2006H61.8376C63.0148 48.2006 63.871 49.121 63.871 50.2982V56.7194H63.8708ZM67.6701 31.3022H37.4049V26.9893C37.4049 25.6837 38.3894 24.6991 39.6951 24.6991H65.4333C66.739 24.6991 67.7236 25.6837 67.7236 26.9893V31.3129H67.6701V31.3022ZM73.4277 73.1576H71.2017V33.9242H73.4277V73.1576Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42,
    width: 25,
    height: 24,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4732 45.5793C49.4732 44.7071 50.1803 44 51.0525 44H53.7182C54.5904 44 55.2975 44.7071 55.2975 45.5793V61.1927C55.2975 62.0649 54.5904 62.772 53.7182 62.772H51.0525C50.1803 62.772 49.4732 62.0649 49.4732 61.1927V45.5793Z",
    fill: "#EF5261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4732 45.5793C49.4732 44.7071 50.1803 44 51.0525 44H53.7182C54.5904 44 55.2975 44.7071 55.2975 45.5793V61.1927C55.2975 62.0649 54.5904 62.772 53.7182 62.772H51.0525C50.1803 62.772 49.4732 62.0649 49.4732 61.1927V45.5793Z",
    stroke: "#EF5261"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52.0535C43 51.1812 43.7071 50.4741 44.5793 50.4741H60.1926C61.0649 50.4741 61.772 51.1812 61.772 52.0535V54.7191C61.772 55.5913 61.0649 56.2984 60.1926 56.2984H44.5793C43.7071 56.2984 43 55.5913 43 54.7191V52.0535Z",
    fill: "#EF5261"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52.0535C43 51.1812 43.7071 50.4741 44.5793 50.4741H60.1926C61.0649 50.4741 61.772 51.1812 61.772 52.0535V54.7191C61.772 55.5913 61.0649 56.2984 60.1926 56.2984H44.5793C43.7071 56.2984 43 55.5913 43 54.7191V52.0535Z",
    stroke: "#EF5261"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 38,
    r: 15,
    fill: "#00AF91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.77 39.532H26.667V44.77H23.103V39.532H18V36.238H23.103V31H26.667V36.238H31.77V39.532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCaseIcon);
export default __webpack_public_path__ + "static/media/startCaseIcon.a0136a512b96612f38fa5362f1962132.svg";
export { ForwardRef as ReactComponent };